import AutoComplete from "components/AutoComplete";
import TableOnly from "components/DataTable/TableOnly";
import Pagination from "components/Pagination/Pagination";
import SearchComp from "components/SearchComp/SearchComp";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import DeleteModalButton from "../../../../components/DeleteModalBtn/DeleteModalButton";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";

let API_URL = "manufacturer/products/product-types";
let COMPONENT_URL = "/manufacturer/products";
let COMPONENT_DETAILS_URL = "/manufacturer/products";

let limits = [5, 10, 15, 20];

export default function MProductTypes() {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  /*   ALL STATES
   ********************************************* */

  const [productTypesData, setProductTypesData] = useState([]);
  const [searchResults, setSearchResults] = useState(null);

  const [totalPages, setTotalPages] = useState(
    parseInt(searchParams.get("totalPages")) || 1
  );
  if (searchParams.get("limit") === null) {
    setSearchParams((prev) => {
      let limit = searchParams.get("limit") || "10";
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", limit);
      return newParams.toString();
    });
  }
  if (searchParams.get("page") === null) {
    setSearchParams((prev) => {
      let page = searchParams.get("page") || "1";
      const newParams = new URLSearchParams(prev);
      newParams.set("page", page);
      return newParams.toString();
    });
  }
  if (searchParams.get("filterBy") === null) {
    setSearchParams((prev) => {
      let filterBy = searchParams.get("filterBy") || "all";
      const newParams = new URLSearchParams(prev);
      newParams.set("filterBy", filterBy);
      return newParams.toString();
    });
  }

  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */

  const changeLimit = (val) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", val);
      return newParams.toString();
    });
  };

  const getSearchParamsWithoutGivenKey = (key) => {
    let params = new URLSearchParams(searchParams);
    params.delete(key);
    return params.toString();
  };

  //get Data
  const getProductTypesData = async () => {
    try {
      setLoading(true);

      let page = parseInt(searchParams.get("page")) || 1;
      let limit = parseInt(searchParams.get("limit")) || 10;
      let query = searchParams.get("query") || "";
      let filterBy = searchParams.get("filterBy") || "all";

      let body = { page, limit, filterBy };

      if (query) {
        body.query = query;
      }

      const { data } = await API.post(API_URL, body, {
        headers: authHeader(),
      });
      if (data.success) {
        setProductTypesData(data.data);
        setTotalPages(data.totalPages);
        setSearchResults(null);
        return data.data;
      } else {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // AutoComplete Search Function
  const searchProductTypes = async (searchText, fieldName) => {
    try {
      setLoading(true);

      const { data } = await API.post(
        "/manufacturer/products/product-type/auto-complete",
        { searchText, fieldName },
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        return data?.data;
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Delete
  const deleteProductTypesData = async (id) => {
    try {
      setLoading(true);
      const { data } = await API.delete(
        "/manufacturer/products/product-type/" + id,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        // setProductTypesData((prev) => prev.filter((item) => item.id !== id));
        await getProductTypesData();
        dispatch(
          setNotification({
            message: data?.message,
            type: "success",
          })
        );
        return;
      }
      dispatch(
        setNotification({
          message: data?.message,
          type: "error",
        })
      );
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Adds Button Function
  const AddProductTypesData = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.post(
        "/manufacturer/products/product-type",
        formData,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        // setProductTypesData((prev) => [...prev, data?.data]);
        await getProductTypesData();
        setFormData({});
        setShowAddModal(false);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }

    setShowAddModal(false);
  };

  // Update Button Function
  const UpdateProductTypesData = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const { data } = await API.patch(
        "/manufacturer/products/product-type",
        formData,
        {
          headers: authHeader(),
        }
      );
      if (data?.success) {
        // setProductTypesData((prev) => {
        //   const newData = prev.map((item) => {
        //     if (item.id === formData.id) {
        //       return data?.data;
        //     }
        //     return item;
        //   });
        //   return newData;
        // });
        await getProductTypesData();
        setIsUpdateMode(false);
        setShowAddModal(false);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateData = async (item) => {
    setFormData(item);
    setIsUpdateMode(true);
    setShowAddModal(true);
  };

  // Sorting Up
  const sortUp = async (id) => {
    const index = productTypesData.findIndex((item) => item.id === id);
    if (index === -1) return;
    if (index === 0) return;
    if (index === productTypesData.length) return;

    const currentSortId = productTypesData[index]?.sortId;
    const currentId = productTypesData[index]?.id;
    const upSortId = productTypesData[index - 1].sortId;
    const upId = productTypesData[index - 1].id;
    try {
      const { data } = await API.post(
        "manufacturer/products/product-type/sortup",
        { currentSortId, currentId, upSortId, upId },
        { headers: authHeader() }
      );
      if (data.success) {
        await getProductTypesData();
      }
    } catch (err) {
      alert(err.message);
    }
  };

  // Sorting Up
  const sortDown = async (id) => {
    const index = productTypesData.findIndex((item) => item.id === id);
    if (index === -1) return;
    if (index === productTypesData.length - 1) return;

    const currentSortId = productTypesData[index]?.sortId;
    const currentId = productTypesData[index]?.id;
    const downSortId = productTypesData[index + 1].sortId;
    const downId = productTypesData[index + 1].id;

    try {
      const { data } = await API.post(
        "manufacturer/products/product-type/sortDown",
        { currentSortId, currentId, downSortId, downId },
        { headers: authHeader() }
      );
      if (data.success) {
        await getProductTypesData();
      }
    } catch (err) {
      alert(err.message);
    }
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      let _filterBy = searchParams.get("filterBy") || "all";
      let _query = searchParams.get("query") || "";
      if (_filterBy && _filterBy !== "all" && !_query) {
        return;
      }
      getProductTypesData();
    }, 50);
    return () => clearTimeout(timeout);
  }, [searchParams]);

  /*   Table functions
   ********************************************* */
  const btn1 = () => (
    <div>
      <>
        <button
          onClick={() => {
            setShowAddModal(true);
            setFormData({});
            setIsUpdateMode(false);
          }}
          type="button"
          className="btn btn-primary  ms-1"
        >
          Add Product Type
        </button>
      </>
    </div>
  );

  const table_head = [
    { name: "ID", value: "id" },
    { name: "Product Type", value: "type" },
    { name: "Actions", value: "Actions" },
  ];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td className="py-0 align-middle">{item.productTypeId}</td>
      <td className="py-0 align-middle">{item.type}</td>

      <td className="py-0 align-middle table-action">
        <button
          onClick={() => {
            item.sort_id !== 1 && sortUp(item?.id);
          }}
          disabled={item.sort_id === 1}
          className="action-icon border-0 btn"
        >
          <i className="mdi mdi-chevron-double-up"></i>
        </button>
        <button
          onClick={() => {
            item.sort_id !== productTypesData.length && sortDown(item?.id);
          }}
          disabled={item.sort_id === productTypesData.length}
          className="action-icon border-0 btn"
        >
          <i className="mdi mdi-chevron-double-down"></i>
        </button>
        <button
          disabled={loading}
          onClick={() => {
            handleUpdateData(item);
          }}
          className="btn px-1 border-0"
        >
          <i className="mdi mdi-pencil"></i>
        </button>

        <DeleteModalButton
          btnClass={"btn  px-1"}
          deleteFunc={deleteProductTypesData}
          deleteParams={item.id}
          disableConditions={loading}
        />
      </td>
    </tr>
  );

  return (
    <div className="p-2" style={{ height: "90vh" }}>
      {loading && <Spinner />}
      {/*   Table
       ********************************************* */}
      <div className="px-2 ">
        <div className="">
          <div className="">
            <div className="d-flex justify-content-end align-items-center gap-1 mb-3">
              <div className="flex-grow-1 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-1">
                  <div>Show</div>
                  <button
                    className="px-1 bg-primary bg-opacity-10 border border-primary rounded-end rounded-start "
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {searchParams.get("limit")}
                  </button>
                  <ul
                    style={{ width: "fit-content" }}
                    className="dropdown-menu"
                  >
                    {limits.map((limit) => (
                      <li key={limit}>
                        <button
                          className="dropdown-item"
                          onClick={() => changeLimit(limit)}
                        >
                          {limit}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <SearchComp
                setLoading={setLoading}
                apiPath={`${COMPONENT_URL}${
                  getSearchParamsWithoutGivenKey("query")
                    ? "?" + getSearchParamsWithoutGivenKey("query") + "&"
                    : "?"
                }`}
              />
              <div className="">{btn1()}</div>
            </div>
            <div
              className="mb-3"
              style={{ height: "75vh", overflowY: "auto", borderRadius: 15 }}
            >
              {searchResults ? (
                <TableOnly
                  table_head={table_head}
                  table_body={table_body}
                  table_data={searchResults}
                  totalPages={totalPages}
                />
              ) : (
                <TableOnly
                  table_head={table_head}
                  table_body={table_body}
                  table_data={productTypesData}
                  totalPages={totalPages}
                />
              )}
            </div>
            {loading && <Spinner />}
            {!searchResults && (
              <Pagination
                totalPages={totalPages}
                apiPath={`${COMPONENT_URL}${
                  searchParams.toString()
                    ? "?" + getSearchParamsWithoutGivenKey("page") + "&"
                    : "?"
                }page=`}
                currPage={parseInt(searchParams.get("page")) || 1}
              />
            )}
          </div>
        </div>
      </div>
      {/*   ADD Modal
       ********************************************* */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Body
          className="shadow-lg bg-white px-3 "
          style={{ borderRadius: 15 }}
        >
          <form
            onSubmit={
              isUpdateMode ? UpdateProductTypesData : AddProductTypesData
            }
            className=""
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h4>
                {isUpdateMode ? "Update Product Type" : "Add Product Type"}
              </h4>
              {/*   buttons
               ********************************************* */}
              <div className="">
                <div className="d-flex justify-content-end">
                  <button
                    onClick={() => {
                      setShowAddModal(false);
                    }}
                    className="btn btn-secondary btn-sm"
                    type="button"
                  >
                    Close
                  </button>
                  <button
                    disabled={loading}
                    className="btn btn-primary btn-sm ms-1"
                    type="submit"
                  >
                    {isUpdateMode ? "Update" : "Add"}
                  </button>
                </div>
              </div>
            </div>
            <hr className="mt-0" />
            <div className="my-3">
              <label className="form-label">Product Type</label>
              <AutoComplete
                fieldName={"type"}
                value={formData?.type || ""}
                handleChange={(key, value) => {
                  setFormData({ ...formData, [key]: value });
                }}
                searchFunction={searchProductTypes}
                placeholder={"Enter Product Type "}
                required
                classNames={"form-control"}
              />
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
}
